import { Skeleton } from '@/components/ui/skeleton';

interface FollowUpWorkflowSkeletonProps {
  message?: string;
}

export function FollowUpWorkflowSkeleton({
  message = 'Loading...'
}: FollowUpWorkflowSkeletonProps) {
  return (
    <div className="container mx-auto max-w-6xl space-y-6 p-6">
      <div className="flex items-center justify-center py-8">
        <div className="space-y-3 text-center">
          <div className="border-primary mx-auto h-8 w-8 animate-spin rounded-full border-3 border-t-transparent" />
          <p className="text-muted-foreground text-sm">{message}</p>
        </div>
      </div>

      <div className="space-y-4">
        <div className="space-y-3 rounded-lg border p-4">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>

        <div className="space-y-3 rounded-lg border p-4">
          <Skeleton className="h-5 w-32" />
          <div className="space-y-2">
            <Skeleton className="h-20 w-full" />
          </div>
        </div>

        <div className="space-y-3 rounded-lg border p-4">
          <Skeleton className="h-5 w-40" />
          <div className="space-y-2">
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
